import "./index.css";
import { withProfiler } from "@sentry/react";
import { DeleteModelProvider } from "components/deleteModal";
import "mapbox-gl/dist/mapbox-gl.css";
import "notyf/notyf.min.css";
import React, { Suspense } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import "react-loading-skeleton/dist/skeleton.css";
import { LayoutProvider } from "./contexts/LayoutContext";
import { SidebarProvider } from "./contexts/SidebarContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import "./i18n";

function App() {
  const Content = React.lazy(() => import("components/AuthContent"));

  return (
    <HelmetProvider>
      <Helmet
        titleTemplate="%s | Modelve - Asset Investment Planning"
        defaultTitle="Modelve - Asset Investment Planning"
      />
      <ThemeProvider>
        <SidebarProvider>
          <LayoutProvider>
            <Suspense>
              <DeleteModelProvider>
                <Content />
              </DeleteModelProvider>
            </Suspense>
          </LayoutProvider>
        </SidebarProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default withProfiler(App);
